/**
 * Returns true if a single time range should be shown on an event card.
 *
 * Rules:
 *   - 1 day                                                   → true  (show time)
 *   - 2+ days, all days share the same start_time AND end_time → true  (show time)
 *   - 2+ days, at least one day differs in start or end time   → false (hide time)
 *
 * Handles both storage systems:
 *   System 1: Event.has_varying_times — precomputed flag from the list API
 *   System 2: event_date_time_info (public detail API) or
 *             event_multiple_days  (applications API) — one object per day
 *
 * @param {object} event - The event or application data object
 * @returns {boolean}
 */
export function shouldShowSingleTime(event) {
  // Precomputed flag — available from list API via EventCard
  if (event?.has_varying_times !== undefined) {
    return !event.has_varying_times;
  }

  // Fallback — per-day rows available directly via AppEventCard
  const perDayRows =
    event?.event_date_time_info ?? event?.event_multiple_days ?? null;

  if (perDayRows !== null && perDayRows.length > 1) {
    const first = perDayRows[0];
    return perDayRows.every(
      (day) =>
        day.start_time === first.start_time &&
        day.end_time === first.end_time,
    );
  }

  return true;
}
